function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import omit from 'lodash/omit';
import AppliedRoute from '@signal/components/AppliedRoute';
import ConditionalRoute from '@signal/components/ConditionalRoute';
import { authFailure, PC_AUTH_COOKIE, PC_AUTH_COOKIE_QA } from '@signal/core/auth';
import withAuth from '@signal/hoc/withAuth';
import { GENERIC_PURECARS_DOMAIN } from '@signal/utils/constants';
import { setCookie } from '@signal/utils/cookies';
import isSnapshot from '@signal/utils/env/isSnapshot';
import { AuthError } from '@signal/utils/errors';
export var AuthenticatedRoute = /*#__PURE__*/function (_React$Component) {
  _inherits(AuthenticatedRoute, _React$Component);

  var _super = _createSuper(AuthenticatedRoute);

  function AuthenticatedRoute() {
    _classCallCheck(this, AuthenticatedRoute);

    return _super.apply(this, arguments);
  }

  _createClass(AuthenticatedRoute, [{
    key: "routeCondition",
    get:
    /**
     * Constructs the route condition for the `ConditionalRoute` component. When
     * the condition fails, the `onFailure` method will redirect the user to the
     * login page instead of rendering the route.
     *
     * The route will be rendered while at least one of the following conditions
     * are met:
     *   - The app is still initializing and authentication is not finished
     *   - The user is authenticated
     *
     * @returns {RouteCondition} - redirects unauthenticated users to login page
     */
    function get() {
      var _this$props = this.props,
          _this$props$auth = _this$props.auth,
          isAuthenticating = _this$props$auth.isAuthenticating,
          isAuthenticated = _this$props$auth.isAuthenticated,
          isAuthInitialized = _this$props$auth.isAuthInitialized,
          authFailure = _this$props.authFailure;
      var isInitializing = isAuthenticating || !isAuthInitialized;
      return {
        condition: isAuthenticated || isInitializing,
        onFailure: authFailure
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$conditio = _this$props2.conditions,
          conditions = _this$props2$conditio === void 0 ? [] : _this$props2$conditio,
          rest = _objectWithoutProperties(_this$props2, ["conditions"]);

      return /*#__PURE__*/React.createElement(ConditionalRoute, Object.assign({
        conditions: [this.routeCondition].concat(_toConsumableArray(conditions))
      }, omit(rest, 'auth')));
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      if (error instanceof AuthError) {
        // if we see an auth error, our cookies must not be valid (prod/QA shift).  Clear cookies and reload
        setCookie({
          name: PC_AUTH_COOKIE,
          domain: GENERIC_PURECARS_DOMAIN,
          value: ''
        });
        setCookie({
          name: PC_AUTH_COOKIE_QA,
          domain: GENERIC_PURECARS_DOMAIN,
          value: ''
        });
        window.location.reload();
      }
    }
  }]);

  return AuthenticatedRoute;
}(React.Component);
/**
 * @NOTE - Bypass AuthenticatedRoute component in static render during build
 * because it should always render the skeleton UI loading state for the page it
 * is trying to render, and we don't want any redirects to take place.
 */

var RouteComponent = isSnapshot() ? AppliedRoute : compose(withAuth(), connect(null, {
  authFailure: authFailure
}))(AuthenticatedRoute);
export default RouteComponent;